import { Ajax } from "../utils/base";
import IP from "../config/config"
import QS from "qs"
// 获取会员基本信息
export function getVipInfo (param) {
    const url = IP.mApis() + '/passport/pay/member/home';
    return Ajax(url, param, "GET");
}
// 获取会员权益列表
export function getVipRight (param) {
    const url = IP.mApis() + '/passport/pay/member/rights';
    return Ajax(url, param, "GET");
}
// 体验会员下单
export function vipBuy (param) {
    const url = IP.mApis() + '/passport/pay/member/buy';
    return Ajax(url, QS.stringify(param), "POST");
}
// 余额不足被动支付
export function commonPay (param) {
    const url = IP.passportApis() + '/pay/unifiedorder';
    return Ajax(url, QS.stringify(param), "POST");
}
// 余额购买
export function balanceBuy (param) {
    const url = IP.passportApis() + '/data/buy';
    return Ajax(url, QS.stringify(param), "POST");
}
// iOS产品ID
export function iosPayConfig (param) {
    const url = IP.passportApis() + '/pay/applePayConf?scene=pay_data';
    return Ajax(url, QS.stringify(param), "POST");
}
